import React from 'react';
import { Redirect } from 'react-router-dom';

import { useSuspensionStatus } from '../../../utils/effects/useSuspensionStatus';
import routes from '../../routes/path';

const SuspendedRoute = ({ component: Component, ...rest }) => {
  const isSuspended = useSuspensionStatus();

  if (isSuspended) {
    return <Redirect to={routes.private.index} />;
  }

  return <Component {...rest} />;
};

export default SuspendedRoute;
